import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import Home from "@Screens/Home/Home"
import AboutUs from "@Screens/Home/AboutUs/AboutUs"
import References from "@Screens/Home/References/References"
import IvehteMissions from "@Screens/Home/AboutUs/IvehteMissions/IvehteMissions"
import IvehteTeam from "@Screens/Home/AboutUs/IvehteTeam/IvehteTeam"
import IvehteHistory from "@Screens/Home/AboutUs/IvehteHistory/IvehteHistory"
import { CustomHeaderComponent } from "@Components/CustomHeader/CustomHeaderComponent"
import UserSettingStack from "@Navigation/UserSettingStack/UserSettingStack"
import VideosDetails from "@Components/CustomVideoItem/VideosDetails/VideosDetails"
import TopicContent from "@Screens/Knowledge/TopicContent/TopicContent"
import DiagnosticConclusion from "@Screens/Home/DiagnosticConclusion/DiagnosticConclusion"
import KnowledgeStack from "@Navigation/KnowledgeStack/KnowledgeStack"
import { EvaluationQuizz } from "@Screens/Knowledge/Savoirs/Evaluation/EvaluationQuizz/EvaluationQuizz"
import ForumTopic from "@Screens/Knowledge/SavoirEtre/Forum/ForumTopic/ForumTopic"
import WorkshopDetails from "@Screens/Knowledge/SavoirFaire/Ateliers/WorkshopDetails/WorkshopDetails"
import { EvaluationStack } from "@Navigation/FollowUp/EvaluationStack"
import CheckConsentScreen from "@Screens/Home/CheckConsentScreen/CheckConsentScreen"
import Consent from "@Screens/Consent/Consent"
import { FollowUpStack } from "@Navigation/FollowUp/FollowUpStack"

const HomeStackNavigator = createNativeStackNavigator()
const HomeStack = () => (
    <HomeStackNavigator.Navigator
        screenOptions={{
            headerShown: true,
            header: (props) => <CustomHeaderComponent {...props} />
        }}
        initialRouteName="HomeScreen"
    >
        <HomeStackNavigator.Screen name="HomeScreen" component={Home} />
        <HomeStackNavigator.Screen name="CheckConsentScreen" component={CheckConsentScreen} />
        <HomeStackNavigator.Screen name="Consent" component={Consent} />
        <HomeStackNavigator.Screen name="UserSettings" component={UserSettingStack} />
        <HomeStackNavigator.Screen name="AboutUs" component={AboutUs} />
        <HomeStackNavigator.Screen name="References" component={References} />
        <HomeStackNavigator.Screen name="IvehteMissions" component={IvehteMissions} />
        <HomeStackNavigator.Screen name="IvehteTeam" component={IvehteTeam} />
        <HomeStackNavigator.Screen name="IvehteHistory" component={IvehteHistory} />
        <HomeStackNavigator.Screen name="VideosDetails" component={VideosDetails} />
        <HomeStackNavigator.Screen name="TopicContent" component={TopicContent} />
        <HomeStackNavigator.Screen name="DiagnosticConclusion" component={DiagnosticConclusion} />
        <HomeStackNavigator.Screen name="ForumTopic" component={ForumTopic} />
        <HomeStackNavigator.Screen name="KnowledgeStack" component={KnowledgeStack} />
        <HomeStackNavigator.Screen name="EvaluationQuizz" component={EvaluationQuizz} />
        <HomeStackNavigator.Screen name="EvaluationStack" component={EvaluationStack} />
        <HomeStackNavigator.Screen name="WorkshopDetails" component={WorkshopDetails} />
        <HomeStackNavigator.Screen name="FollowUpStack" component={FollowUpStack} />
    </HomeStackNavigator.Navigator>
)

export default HomeStack
